import { render, staticRenderFns } from "./FBModeredit.vue?vue&type=template&id=19fc70ad&scoped=true"
import script from "./FBModeredit.vue?vue&type=script&lang=js"
export * from "./FBModeredit.vue?vue&type=script&lang=js"
import style0 from "./FBModeredit.vue?vue&type=style&index=0&id=19fc70ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc70ad",
  null
  
)

export default component.exports